/**
 * Boolean logical operator: !p or q
 * @param {*} p precedent
 * @param {*} q antecedent
 * @returns true iff p implies q
 */
export function implies(p, q) {
  return !p || q;
}
